<template>
  <div class="card">
    <div class="card-header border-0">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0">การใช้งานตามเวลา</h3>
        </div>
        <div class="col text-right">
          <a href="#/deposit" class="btn btn-sm btn-primary">ดูทั้งหมด</a>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <base-table thead-classes="thead-light"
                  :data="tableData">
        <template slot="columns">
          <th style="font-size:14px">เวลา</th>
          <th style="font-size:14px">การใช้งาน (ครั้ง)</th>
          <th style="font-size:14px">ยอดใช้งาน (บาท)</th>
        </template>

        <template slot-scope="{row}">
          <th scope="row">
            {{row.start_time}} - {{row.to_time}}
          </th>
          <td>
            {{row.used}}
          </td>
          <td>
            {{row.amount}} ฿
          </td>
          <!-- <td>
            <i class="fas fa-arrow-up text-success mr-3"
               :class="row.bounceRateDirection === 'up' ? 'text-success': 'text-danger'">
            </i>
            {{row.bounceRate}}
          </td> -->
        </template>
      </base-table>
    </div>

  </div>
</template>
<script>
  import JwService from '../../service/justwash';
  import userProfile from './../UserProfile.vue';

  export default {
    name: 'page-visits-table',
    data() {
      return {
        tableData: null
        // tableData: [
        //   {
        //     page: '/argon/',
        //     visitors: '4,569',
        //     unique: '340',
        //     bounceRate: '46,53%',
        //     bounceRateDirection: 'up'
        //   },
        //   {
        //     page: '/argon/index.html',
        //     visitors: '3,985',
        //     unique: '319',
        //     bounceRate: '46,53%',
        //     bounceRateDirection: 'down'
        //   },
        //   {
        //     page: '/argon/charts.html',
        //     visitors: '3,513',
        //     unique: '294',
        //     bounceRate: '36,49%',
        //     bounceRateDirection: 'down'
        //   },
        //   {
        //     page: '/argon/tables.html',
        //     visitors: '2,050',
        //     unique: '147',
        //     bounceRate: '50,87%',
        //     bounceRateDirection: 'up'
        //   },
        //   {
        //     page: '/argon/profile.html',
        //     visitors: '1,795',
        //     unique: '190',
        //     bounceRate: '46,53%',
        //     bounceRateDirection: 'down'
        //   }
        // ]
      }
    },
    mounted() {
      axios({
        method: 'post',
        url: JwService.getAPI()+'/api/method/justwash.OwnerApi.GetTimeStats',
        data: {},
        headers: {
          'Authorization' : 'Token '+localStorage.getItem('accessToken')
        }
      }).then((response) => {
        if (response.data.message.status == true) {
          this.tableData = response.data.message.data
          // console.log(this.tableData);
          // for (let idx in  response.data.message.data) {
          //   console.log(idx)
          // }
          // console.log(this.cardData);
          // console.log(response.data.message.data.graph_summary);
          // this.$router.push('/dashboard')
        } else {
          this.$router.push('/login')
        }
      }).catch(error => {
        console.log(error)
        // this.$router.push('/login')
      });
    }
  }
</script>
<style>
</style>
